module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"CancelBooking":"Annulla l\u0027appuntamento","CompleteBooking":"Completa","billingInfo":"Dati di fatturazione","ModifyBooking":"Modifica l\u0027appuntamento"}}')
  delete Component.options._Ctor
}
